// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidenav---sidenav---_2tBP{position:absolute;top:0;bottom:0;left:0;z-index:1006;min-width:64px;background:#4575B4;-webkit-transition:min-width 0.15s;-moz-transition:min-width 0.15s;-o-transition:min-width 0.15s;-ms-transition:min-width 0.15s;transition:min-width 0.15s;height:200%}\n", ""]);
// Exports
module.exports = exports;
